import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports
import type { PayloadAction } from "@reduxjs/toolkit";

import type { ChangePhoneNumberFormSubmitPayload } from "@src/components/ChangePhoneNumber/ChangePhoneNumber.types";

import type { ResendOtpPayload, SubmitOtpPayload } from "./Otp.types";


const initialState = {};

const otpSlice = createSlice({
  name: "otp",
  initialState,
  reducers: {
    submitChangePhoneNumberForm(state, action: PayloadAction<ChangePhoneNumberFormSubmitPayload>) {
      return state;
    },
    resendOtp(state, action: PayloadAction<ResendOtpPayload>) {
      return state;
    },
    submitOtpForm(state, action: PayloadAction<SubmitOtpPayload>) {
      return state;
    },
    destroy() {
      return initialState;
    }
  }
});


export default otpSlice.reducer;
export const {
  submitChangePhoneNumberForm,
  resendOtp,
  submitOtpForm,
  destroy
} = otpSlice.actions;
export const otpActions = otpSlice.actions;
